export default __webpack_public_path__ + "static/Montserrat-Bold-bea823a1a24bcdf65760097ede9651d1.eot";